import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import getConfig from  "api/lib/data/FirebaseConfig";


if (!firebase.apps.length) {
  firebase.initializeApp(getConfig());
}

export const firebaselogin = firebase;


// WEBPACK FOOTER //
// ./src/firebase/firebaselogin.ts